import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { getArrowColumnWidth, getItemsColumnWidth } from './BasicCarousel.utils';
import useResponsive from '../../../../../../hooks/use-responsive';
import { toArray } from '../../../../../../services/components';
import Pagination from '../../../Pagination';
import { displayCarouselControls, getAutoScrollInterval, getPageSize, showIndicators } from '../../services';
import { getStepSize } from '../../services/carousel';
import { ARROW_POSITION } from '../../services/constants';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps, DEFAULT_MOBILE_PROPS } from '../../types/base';
import './BasicCarousel.css';
var defaultProps = BaseCarouselDefaultProps;
export default function BasicCarousel(_ref) {
  var items = _ref.items,
    size = _ref.size,
    stepSize = _ref.stepSize,
    grouping = _ref.grouping,
    autoScroll = _ref.autoScroll,
    responsive = _ref.responsive,
    continuous = _ref.continuous,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    className = _ref.className,
    mobile = _ref.mobile,
    renderItemContainer = _ref.renderItemContainer,
    displayIndicators = _ref.displayIndicators,
    displayPlayPauseButton = _ref.displayPlayPauseButton,
    displayLeftRightArrows = _ref.displayLeftRightArrows,
    animation = _ref.animation,
    leftArrowIcon = _ref.leftArrowIcon,
    rightArrowIcon = _ref.rightArrowIcon;
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile;
  var mobilePropsWithDefaults = _objectSpread(_objectSpread({}, DEFAULT_MOBILE_PROPS), mobile);
  var displayAllMobile = mobile.displayAll,
    arrowsPositionMobile = mobile.arrowsPosition;
  var autoScrollInterval = getAutoScrollInterval(autoScroll);
  var pageSize = getPageSize(items, size, responsive, mobilePropsWithDefaults);
  var finalStepSize = getStepSize(items, pageSize, stepSize, grouping);
  var displayControls = displayCarouselControls(pageSize, items);
  if (_isEmpty(items)) {
    return null;
  }
  var leftArrow = /*#__PURE__*/React.createElement(Grid.Column, {
    width: getArrowColumnWidth(isMobile, arrowsPositionMobile),
    verticalAlign: "middle",
    textAlign: "left",
    className: "left-arrow-column"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: "previous",
    icon: leftArrowIcon
  }));
  var rightArrow = /*#__PURE__*/React.createElement(Grid.Column, {
    width: getArrowColumnWidth(isMobile, arrowsPositionMobile),
    verticalAlign: "middle",
    textAlign: "right",
    className: "right-arrow-column"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: "next",
    icon: rightArrowIcon
  }));
  var itemsColumn = /*#__PURE__*/React.createElement(Grid.Column, {
    width: getItemsColumnWidth(isMobile, displayControls, arrowsPositionMobile, displayLeftRightArrows),
    textAlign: "center",
    className: "pagination-elements-column"
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: isMobile && displayAllMobile ? 2 : pageSize,
    verticalAlign: "middle",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    return activeItems.map(renderItemContainer);
  })));
  var content = [itemsColumn];
  if (displayLeftRightArrows && displayControls) {
    content = [leftArrow, itemsColumn, rightArrow];
    if (isMobile) {
      if (arrowsPositionMobile === ARROW_POSITION.top) {
        content = [leftArrow, rightArrow, itemsColumn];
      }
      if (arrowsPositionMobile === ARROW_POSITION.bottom) {
        content = [itemsColumn, leftArrow, rightArrow];
      }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel basic-carousel ".concat(className)
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    grouping: grouping,
    stepSize: finalStepSize,
    items: toArray(items),
    carousel: true,
    continuous: continuous,
    autoScroll: !!autoScroll,
    autoScrollInterval: autoScrollInterval,
    animation: animation
  }, /*#__PURE__*/React.createElement(Grid, null, content, displayControls && /*#__PURE__*/React.createElement(Grid.Column, {
    width: 16,
    className: "indicators-column",
    verticalAlign: "top",
    textAlign: "center"
  }, displayIndicators && !!pageIndicatorIcon && /*#__PURE__*/React.createElement(Pagination.Indicators, {
    onlyPageIndicators: true,
    pageIndicatorIcon: pageIndicatorIcon,
    show: showIndicators(pageSize, items)
  }), displayPlayPauseButton && /*#__PURE__*/React.createElement(Pagination.Play, null)))));
}
BasicCarousel.defaultProps = defaultProps;